import { VcfDomain } from 'pcs-domain';
import { IWldInputProductConfig } from "../wld-input-configuration-factory.service";

export class VCF_9_0_0_STANDARD_WORKLOAD implements IWldInputProductConfig {
    configuration: VcfDomain.Group = {
        "groupId": "workloadDomainComponents",
        "groupName": "Workload Domain Components",
        "groupLabel": "Provide details for sizing software components for this workload domain.",
        "subGroups": [
            {
                "id": 37,
                "subGroupId": "VCENTER",
                "subGroupName": "Deploy VMware vCenter",
                "label": "You can choose the size of vCenter for the Workload Domain. We will provide you with the sizing recommendation.",
                "documentLink": "https://techdocs.broadcom.com/us/en/vmware-cis/vcf/vcf-9-0-and-later/9-0/infrastructure-operations/network-operationss/working-with-data-sources/adding-a-data-source-in-vrealize-network-insight/supported-vmware-managers/add-vcenter-server.html",
                "documentLabel": "Learn More",
                "isEnabled": true,
                "isRequired": true,
                "inputs": [
                    {
                        "id": "sizing",
                        "type": "COMPONENT_DROPDOWN",
                        "label": "Pick the appropriate size to deploy vCenter *",
                        "isRequired": true,
                        "isEnabled": true,
                        "default": "MEDIUM",
                        "minNumberOfVms": 0,
                        "predicate": {},
                        "options": [],
                        "componentSizing": [
                            { "id": "TINY", "overheads": [{ "id": "", "name": "", "resources": {} }] },
                            { "id": "SMALL", "overheads": [{ "id": "", "name": "", "resources": {} }] },
                            { "id": "MEDIUM", "overheads": [{ "id": "", "name": "", "resources": {} }] },
                            { "id": "LARGE", "overheads": [{ "id": "", "name": "", "resources": {} }] },
                            { "id": "X-LARGE", "overheads": [{ "id": "", "name": "", "resources": {} }] }
                        ]
                    }
                ]
            },
            {
                "id": 21,
                "subGroupId": "NSX-MANAGER",
                "subGroupName": "Deploy VMware NSX Manager",
                "label": "You can choose to have a dedicated NSX manager just for this Workload domain or you could share this with other workload domains.",
                "documentLink": "https://techdocs.broadcom.com/us/en/vmware-cis/vcf/vcf-9-0-and-later/9-0/advanced-network-management/administration-guide/nsx-manager.html",
                "documentLabel": "Learn More",
                "isEnabled": true,
                "isRequired": true,
                "inputs": [
                    {
                        "id": "deploymentType",
                        "type": "RADIO",
                        "label": "Do you want a dedicated or a shared NSX Manager for this Workload Domain?",
                        "isRequired": true,
                        "isEnabled": true,
                        "predicate": {},
                        "default": "shared",
                        "options": [
                            { "id": "shared", "label": "Shared" },
                            { "id": "dedicated", "label": "Dedicated" }
                        ]
                    },
                    {
                        "id": "sizing",
                        "type": "COMPONENT_DROPDOWN",
                        "label": "Pick the appropriate size to deploy NSX Manager *",
                        "isRequired": true,
                        "isEnabled": true,
                        "default": "MEDIUM",
                        "minNumberOfVms": 0,
                        "predicate": {},
                        "options": [],
                        "componentSizing": [
                            { "id": "MEDIUM", "overheads": [{ "id": "", "name": "", "resources": {} }] },
                            { "id": "LARGE", "overheads": [{ "id": "", "name": "", "resources": {} }] },
                            { "id": "X-LARGE", "overheads": [{ "id": "", "name": "", "resources": {} }] }
                        ]
                    }
                ]
            },
            {
                "id": 36,
                "subGroupId": "NSX-EDGE",
                "subGroupName": "Deploy VMware NSX Edge",
                "label": "You can choose NSX Edge for the Workload Domain based on your throughput requirement.",
                "documentLink": "https://techdocs.broadcom.com/us/en/vmware-cis/vcf/vcf-9-0-and-later/9-0/advanced-network-management/administration-guide/installing-nsx-edge.html",
                "documentLabel": "Learn More",
                "isEnabled": false,
                "isRequired": false,
                "inputs": [
                    {
                        "id": "sizing",
                        "type": "COMPONENT_DROPDOWN",
                        "label": "Pick the appropriate size to deploy NSX Edge *",
                        "isRequired": false,
                        "isEnabled": false,
                        "default": "MEDIUM",
                        "minNumberOfVms": 0,
                        "predicate": {},
                        "options": [],
                        "componentSizing": [
                            { "id": "SMALL", "overheads": [{ "id": "", "name": "", "resources": {} }] },
                            { "id": "MEDIUM", "overheads": [{ "id": "", "name": "", "resources": {} }] },
                            { "id": "LARGE", "overheads": [{ "id": "", "name": "", "resources": {} }] },
                            { "id": "X-LARGE", "overheads": [{ "id": "", "name": "", "resources": {} }] }
                        ]
                    }
                ]
            },
            {
                "id": 0,
                "subGroupId": "HCX",
                "subGroupName": "Deploy HCX Manager",
                "label": "This will include VCF HCX Manager, Interconnect, and Network Extension.",
                "documentLink": "https://techdocs.broadcom.com/us/en/vmware-cis/vcf/vcf-9-0-and-later/9-0/infrastructure-operations/network-operationss/entities/system-dashboards/viewing-hcx-manager-details.html",
                "documentLabel": "Learn More",
                "isEnabled": false,
                "isRequired": false,
                "inputs": [
                    {
                        "id": "hcxComponentInfo",
                        "type": "COMPONENT_DROPDOWN",
                        "label": "",
                        "isRequired": false,
                        "isEnabled": true,
                        "default": "fixed",
                        "minNumberOfVms": 0,
                        "predicate": {},
                        "options": [
                            {
                                "id": "fixed",
                                "label": ""
                            }
                        ],
                        "componentSizing": [
                            {
                                "id": "fixed",
                                "overheads": [
                                    { "id": "HCX-MANAGER", "name": "HCX Unified Manager", "resources": {} },
                                    { "id": "HCX-IX", "name": "HCX Interconnect", "resources": {} },
                                    { "id": "HCX-NE", "name": "HCX Network Extension", "resources": {} }
                                ]
                            }
                        ]
                    },
                    {
                        "id": "migrateNonVsphere",
                        "type": "RADIO",
                        "label": "Do you plan to migrate any non-vSphere workloads?",
                        "isRequired": true,
                        "isEnabled": true,
                        "predicate": {},
                        "options": [
                            { "id": "yes", "label": "Yes" },
                            { "id": "no", "label": "No", "isDefault": true }
                        ]
                    },
                    {
                        "id": "hcxSrgSizing",
                        "type": "COMPONENT_DROPDOWN",
                        "label": "",
                        "isRequired": false,
                        "isEnabled": true,
                        "minNumberOfVms": 0,
                        "predicate": {
                            "operator": "OR",
                            "conditions": [{ "key": "migrateNonVsphere", "value": "yes", "operation": "EQUALS" }]
                        },
                        "options": [{ "id": "fixed", "label": "" }],
                        "componentSizing": [
                            {
                                "id": "fixed",
                                "overheads": [
                                    { "id": "HCX-SRG", "name": "Sentinel Replication Gateway", "resources": {} }
                                ]
                            }
                        ]
                    }
                ]
            },
            {
                "id": 39,
                "subGroupId": "AVI_SERVICE_ENGINE",
                "subGroupName": "AVI Service Engine",
                "label": "AVI Service Engine for load balancing workloads.",
                "documentLink": "https://techdocs.broadcom.com/us/en/vmware-security-load-balancing/avi-load-balancer/avi-load-balancer-vmware-cloud-foundation/9-0/deploying-vsphere-supervisor-with-vds-and-avi-load-balancer/install-and-configure-the-nsx-advanced-load-balancer/configure-a-service-engine-group.html#:~:text=Requirements%20for%20deploying%20Avi%20Load,Default%2DGroup",
                "documentLabel": "Learn More",
                "isEnabled": false,
                "isRequired": false,
                "inputs": [
                    {
                        "id": "sizing",
                        "type": "COMPONENT_DROPDOWN",
                        "label": "Pick the appropriate size to deploy AVI Service Engine *",
                        "isRequired": false,
                        "isEnabled": true,
                        "default": "MEDIUM",
                        "minNumberOfVms": 2,
                        "predicate": {},
                        "options": [],
                        "componentSizing": [
                            { "id": "SMALL", "overheads": [{ "id": "", "name": "", "resources": {} }] },
                            { "id": "MEDIUM", "overheads": [{ "id": "", "name": "", "resources": {} }] },
                            { "id": "LARGE", "overheads": [{ "id": "", "name": "", "resources": {} }] },
                            { "id": "X-LARGE", "overheads": [{ "id": "", "name": "", "resources": {} }] }
                        ]
                    }
                ]
            }
        ]
    };

    getProductInfo(): string { throw new Error("Method not implemented."); }
    getDatabaseConnectionString(): string { throw new Error("Method not implemented."); }
    getApiEndpoint(): string { throw new Error("Method not implemented."); }
    getDeploymentStrategy(): string { throw new Error("Method not implemented."); }
}
